import { ArrowLeft } from 'lucide-react';
import { createButton, type ClickProps } from './createButton';

export const BackButton = createButton<ClickProps>({
  className:
    'ml-16 flex h-8 items-center gap-2 rounded-lg text-[13px] text-zinc-500 transition-colors hover:text-zinc-300',
  content: (
    <>
      <ArrowLeft className="h-4 w-4" />
      Back
    </>
  ),
});
